// extracted by mini-css-extract-plugin
export default {"discount":"jcjAATdeibfhxC0PShHbag==","no-bottom":"_3O+nbvGm+Da8tH7ryl8t3A==","title":"NooVLPrwiQeCXsRjrkKiCw==","description":"-DalUljS5r8V36qqwcQCZA=="};